<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    class="card"
    v-if="loaded"
  >
    <DIV
      class="card-header d-flex align-items-center"
    >
      <DIV>
        <SPAN>
          {{ 'Notifications'|gettext }}
        </SPAN>
        <SPAN
          class="badge badge-secondary ml-2"
          v-if="items.length"
        >
          {{ items.length }}
        </SPAN>
      </DIV>
      <DIV
        class="ml-auto"
      >
      </DIV>
      <DIV>
        <ItpButton
          icon="fa-sync"
          :tooltip="'Reload'|gettext"
          :spinning="actions.reload.isRunning"
          size="sm"
          variant="link"
          @click="evh_8697745105058001_click($event, {})"
        >
        </ItpButton>
      </DIV>
    </DIV>
    <UL
      class="list-group list-group-flush"
      v-if="items.length"
      :style="b_3343864469950044_style"
    >
      <LI
        :key="item.id"
        class="list-group-item"
        v-for="item in items"
      >
        <ItpBox>
          <UcExpiringContractNotificationCard
            :notification="item"
            v-if="item.type == 'expiring_contract'"
          >
          </UcExpiringContractNotificationCard>
          <UcInflationIndexedPriceChangeNotificationCard
            :notification="item"
            v-if="item.type == 'inflation_indexed_price_change'"
          >
          </UcInflationIndexedPriceChangeNotificationCard>
          <UcInvoiceImportNotificationCard
            :notification="item"
            v-if="item.type.startsWith('invoice:')"
          >
          </UcInvoiceImportNotificationCard>
          <button
            data-dismiss="modal"
            :aria-label="'Remove'|gettext"
            :title="'Remove'|gettext"
            class="close ml-auto mt-2 mr-2 pl-4 align-self-start"
            @click="evh_1840158740026147_click($event, {item})"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ItpBox>
      </LI>
    </UL>
    <DIV
      class="card-body"
      v-if="!items.length"
    >
      <p
        class="card-text"
      >
        {{ 'No new notifications.'|gettext }}
      </p>
    </DIV>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class Notifications extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_notification', { parameters: { state: 'new' } })
      .then(p => _.orderBy(p, ['created_at'], ['desc']))
  }

  ux!: any;
  b_3343864469950044_style!: any;
  dataMembers = ['items', 'ux', 'b_3343864469950044_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
        b_3343864469950044_style: {
          overflow: "auto",
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async evh_8697745105058001_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8697745105058001_click.executeFromDOM(this, event, scope);
  }

  async act_1840158740026147_request_3088_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1840158740026147_request_3088, alias=markRead
    return {
      operation: "update_notification",
      data: {
        id: $event.scope.item.id,
        etag: $event.scope.item.etag,
        state: 'handled',
        result_notes: this.notes,
      },
    }
  }

  async evh_1840158740026147_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1840158740026147_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_3084: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_3083: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8697745105058001_reloadComponentData_3086: actions.ReloadComponentDataAction;
    evh_8697745105058001_click_3085: actions.EventHandlerImpl;
    evh_8697745105058001_click: actions.EventHandlerGroup;
    act_1840158740026147_reloadComponentData_3090: actions.ReloadComponentDataAction;
    evh_1840158740026147_success_3089: actions.EventHandlerImpl;
    act_1840158740026147_request_3088: actions.RequestAction;
    evh_1840158740026147_click_3087: actions.EventHandlerImpl;
    evh_1840158740026147_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_3084 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_3083 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_3084,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_3083],
      }
    );
    const act_8697745105058001_reloadComponentData_3086 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8697745105058001_click_3085 = new actions.EventHandlerImpl(
      {
        action: act_8697745105058001_reloadComponentData_3086,
        event: "click",
        displayName: "reload",
      }
    );
    const evh_8697745105058001_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8697745105058001_click_3085],
      }
    );
    const act_1840158740026147_reloadComponentData_3090 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1840158740026147_success_3089 = new actions.EventHandlerImpl(
      {
        action: act_1840158740026147_reloadComponentData_3090,
        event: "success",
        displayName: "reloadComponentData",
      }
    );
    const act_1840158740026147_request_3088 = new actions.RequestAction(
      {
        actionArgs: this.act_1840158740026147_request_3088_getActionArgs,
        displayName: "markRead",
        events: [evh_1840158740026147_success_3089],
      }
    );
    const evh_1840158740026147_click_3087 = new actions.EventHandlerImpl(
      {
        action: act_1840158740026147_request_3088,
        event: "click",
        displayName: "markRead",
      }
    );
    const evh_1840158740026147_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1840158740026147_click_3087],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_3084,
      evh_7315092382398562_reload_3083,
      evh_7315092382398562_reload,
      act_8697745105058001_reloadComponentData_3086,
      evh_8697745105058001_click_3085,
      evh_8697745105058001_click,
      act_1840158740026147_reloadComponentData_3090,
      evh_1840158740026147_success_3089,
      act_1840158740026147_request_3088,
      evh_1840158740026147_click_3087,
      evh_1840158740026147_click,
      reload: act_8697745105058001_reloadComponentData_3086,
      markRead: act_1840158740026147_request_3088,
    }
  }
}

Vue.component("Notifications", Notifications);

</script>